/**
 * Utilitário de Geração de Chaves de Idempotência
 * 
 * Gera chaves únicas para prevenir duplicação de operações em retries.
 */

/**
 * Gera chave de idempotência para operações de exportação
 * 
 * A chave é composta por: tipo de operação, diretório base, IDs do pedido
 * e assinatura dos itens processados.
 * 
 * @param kind - Tipo de operação ('batch', 'png', 'simple')
 * @param baseDir - Diretório base de destino
 * @param orcId - ID do orçamento
 * @param oitId - ID do item do orçamento
 * @param items - Array de itens com staticId e guid
 * @returns Chave de idempotência (máx 200 caracteres)
 * 
 * @example
 * const key = buildIdempotencyKey(
 *   'batch',
 *   'C:\\producao',
 *   12345,
 *   67890,
 *   [{ staticId: 'obj1', guid: 'guid1' }]
 * );
 * // "batch|C:\producao|12345|67890|obj1:guid1"
 */
export function buildIdempotencyKey(
  kind: 'batch' | 'png' | 'simple',
  baseDir: string,
  orcId: string | number,
  oitId: string | number,
  items: Array<{ staticId: string; guid?: string }>
): string {
  const sig = items.map(i => `${i.staticId}:${i.guid || ''}`).join('|');
  return `${kind}|${baseDir}|${orcId}|${oitId}|${sig}`.slice(0, 200);
}

